const LS_EDITOR_CURRENT_QUERY = 'LS_EDITOR_CURRENT_QUERY'

export {LS_EDITOR_CURRENT_QUERY}
